// BackToTopButton.js
'use client';

import React, { useState, useEffect } from 'react';
import ArrowUpLineIcon from 'remixicon-react/ArrowUpLineIcon';
import { usePathname } from 'next/navigation';

const BackToTopButton = () => {
    const pathname = usePathname();
    const [isVisible, setIsVisible] = useState(false);

    // Define the list of pathnames where the button should be disabled
    const disabledSlugs = [
        '/crypto-exchange/',
        '/best-iranian-crypto-exchanges/',
        '/best-broker/',
        '/prop/',
        '/gold-platforms/',
    ];

    // Determine if the current pathname is in the disabled list
    const isDisabled = disabledSlugs.includes(pathname) || pathname.startsWith('/symbol/');

    const toggleVisibility = () => {
        setIsVisible(window.scrollY > 20);
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        window.addEventListener('scroll', toggleVisibility);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', toggleVisibility);
        };
    }, []);

    // If the button should be disabled on the current path, don't render it
    if (isDisabled) {
        return null; // Hides the button on disabled paths
    }

    return (
        <button
            aria-label='Back to top'
            title='Back to top'
            onClick={scrollToTop}
            className={`${isVisible ? 'right-4 opacity-100' : '-right-20 opacity-0'} fixed bottom-20 z-10 rounded-full bg-primary p-3 leading-none text-white shadow-md transition-all duration-300 ease-in-out hover:-translate-y-2 dark:bg-white dark:text-primary`}
        >
            <ArrowUpLineIcon size={16} />
        </button>
    );
};

export default BackToTopButton;
